var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-layout',[_c('h1',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n    "+_vm._s(_vm._f("trans")(`app.pages.products_weights`))+"\n  ")]),_vm._v(" "),_c('v-app',{attrs:{"id":"vuetify-app"}},[_c('products-weights-table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }